<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div style="float:left" class="d-flex">
        <!-- LOGO -->
        <button
            id="toggle"
            type="button"
            class="btn btn-sm font-size-20 d-lg-none header-item"
            @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <button
            id="popover-target-1"
            class="btn btn-sm font-size-12 d-sm-none d-xl-none d-lg-none header-item"
        >
          <v-icon class="mb-1" style="color: darkblue" small color="info">mdi-information-outline</v-icon>
        </button>
        <b-popover target="popover-target-1" triggers="click" placement="rightbottom">
          <div>
            <v-chip label v-if="erpSettings.netsisCurrencySale"
                    style="display: block; background-color:#34c38f75; margin-bottom: 4px;">
              <v-icon small>mdi-currency-usd</v-icon>
              {{ dollar }}
            </v-chip>
            <v-chip label v-if="erpSettings.netsisCurrencySale"
                    style="display: block; background-color:#34c38f75; margin-bottom: 4px;">
              <v-icon small>mdi-currency-eur</v-icon>
              {{ euro }}
            </v-chip>
            <v-chip label v-if="erpSettings.netsisCurrencySale"
                    style="display: block; background-color:#34c38f75; margin-bottom: 4px;">
              <v-icon small>mdi-currency-gbp</v-icon>
              {{ pound }}
            </v-chip>
          </div>
        </b-popover>


        <div class="navbar-brand-box my-auto">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-lg">
              <img
                  :src="logoFromConfig()"
                  alt
                  height="30"
              />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light my-auto">
            <span class="logo-lg">
              <img
                  :src="logoFromConfig()"
                  alt
                  height="30"
              />
            </span>
          </router-link>
        </div>

        <!-- App Search-->
        <div class="d-none d-lg-block pt-4">
          <search-select
              :search-type="'stock'"
              @itemChange="(e) => (selectedStock = e)"
              :placeholder="'Ürün Arayın...'"
          >
          </search-select>
        </div>
      </div>

      <div class="d-flex">
        <v-chip label v-if="erpSettings.netsisCurrencySale" style="background-color:#34c38f75; margin-right: 10px;"
                class="d-none d-sm-inline-block d-xl-inline-block align-self-center">
          <v-icon small>mdi-currency-usd</v-icon>
          {{ dollar }}
        </v-chip>
        <v-chip label v-if="erpSettings.netsisCurrencySale" style="background-color:#34c38f75; margin-right: 10px;"
                class="d-none d-sm-inline-block d-xl-inline-block align-self-center">
          <v-icon small>mdi-currency-eur</v-icon>
          {{ euro }}
        </v-chip>
        <v-chip label v-if="erpSettings.netsisCurrencySale" style="background-color:#34c38f75; margin-right: 10px;"
                class="d-none d-sm-inline-block d-xl-inline-block align-self-center">
          <v-icon small>mdi-currency-gbp</v-icon>
          {{ pound }}
        </v-chip>
        <div>
          <b-dropdown
              menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
              toggle-class="header-item noti-icon"
              variant="black"
              :style="{ width: current ? '200px' : '60px' }"
          >
            <template v-slot:button-content>
              <div class="row ">
                <div class="col-4">
                  <i class="bx bx-basket" :class="{ 'bx-tada': cartList.length > 0 }"></i>
                  <span class="badge bg-danger rounded-pill">
                  {{ cartList.length }}
                </span>
                </div>
                <div class="col-8" style="padding-left: 0">
                  <span class="d-inline-block text-truncate ms-2" style="max-width: 120px;">
                    {{ current ? current.name : "" }}</span>
                </div>
              </div>
            </template>


            <div class="p-3 bg-dark bg-opacity-75">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="text-light" v-if="current">
                    Seçili Cari : <b>{{ current.name }}</b>
                    <br>
                    Cari Kodu : <b>{{current.code}}</b>
                    <br>
                    Döviz Tipi : <b>{{fetchCurrencyLabel(current.currencyType)}}</b>
                  </h6>
                  <h6 class="text-light" v-if="current">
                    Müşteri Temsilcisi : {{ current.salesPersonName }}
                  </h6>
                  <div class="text-center" v-else>
                    <h5 class="text-light">Cari Seçilmedi</h5>
                    <p class="text-light">
                      Sepetinize Ürün Eklemek İçin Lütfen Cari Seçimi Yapınız
                    </p>
                    <router-link :to="'/current-list'">
                      <v-btn ripple x-small>CARİ SEÇ</v-btn>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <simplebar style="max-height: 250px">
              <a
                  href="javascript: void(0);"
                  class="text-reset notification-item"
                  v-for="item in cartList"
                  :key="item.stockCode"
              >
                <div class="d-flex">
                  <div class="d-flex flex-column p-0 pe-2 align-self-center">
                    <v-btn
                        style="background-color: #34c38f"
                        class="mb-1"
                        rounded
                        x-small
                        @click="changeQuantityOfProduct(item, 1)"
                    ><i class="mdi mdi-plus"></i
                    ></v-btn>
                    <v-btn
                        class="mb-1"
                        x-small
                        rounded
                        @click="changeQuantityOfProduct(item, -1)"
                        :disabled="item.quantity < 2"
                    ><i class="mdi mdi-minus"></i
                    ></v-btn>
                  </div>

                  <div class="flex-grow-1">
                    <h6 class="mt-0 mb-1">
                      {{ item.stockName }}
                    </h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">Stok Kodu : {{ item.stockCode }}</p>
                      <p class="mb-0">Miktar : {{ item.quantity }}</p>
                    </div>
                  </div>
                  <div class="align-self-center">
                    <v-btn
                        class="mb-1"
                        style="background-color: rgb(244, 106, 106)"
                        x-small
                        @click="cartStockRemove(item)"
                    ><i class="mdi mdi-delete" style="font-size: 15px"></i
                    ></v-btn>
                  </div>
                </div>
              </a>
            </simplebar>

            <div
                class="p-5 border-top d-grid text-center"
                v-if="cartList.length < 1"
            >
              <h6>Sepetiniz Boş</h6>
              <p>Ürün eklemek için Stok sayfasına gidin</p>
              <router-link :to="'/stock-list'">
                <v-btn style="background-color: moccasin" x-small>Stoklara Git</v-btn>
              </router-link>
            </div>
            <div class="p-2 border-top d-grid justify-content-center" v-if="cartList.length > 0">
              <router-link
                  :to="'/cart'"
              >
                <v-btn
                    style="background-color: gold; width: 140px">
                  <i class="mdi mdi-arrow-right-circle me-1"></i>
                  <span key="t-view-more"> Sepete Git</span>
                </v-btn>
              </router-link>
            </div>
            <div class="p-2 border-top d-grid justify-content-center">
              <v-btn
                  style="background-color: #d9d9d9"
                  small
                  v-if="current"
                  @click="openCurrentActionsDialog(current)"
              >Cari Hareketleri
              </v-btn>
            </div>

            <div
                class="p-2 border-top d-grid text-center"
                v-if="current"
            >
              <v-btn
                  v-if="user.RoleGroupId !== '3'"
                  style="background-color: rgb(244, 106, 106)"
                  variant="danger"
                  x-small
                  @click="cancelCurrent"
              >
                Seçimi Bırak
              </v-btn>
            </div>

          </b-dropdown>
          <v-btn
              v-if="current && user.RoleGroupId !== '3'"
              style="width: 15px; height: auto; color:rgb(244, 106, 106);"
              class="d-none d-sm-inline-block d-xl-inline-block align-self-center"
              icon
              type="button"
              @click="cancelCurrent"
          >
            <v-icon small>mdi-cancel</v-icon>
          </v-btn>
        </div>
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <span class=" d-xl-inline-block ms-1">{{
                user ? user.FullName : ""
              }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <b-dropdown-item @click="openChangePasswordDialog(user)" class="d-block" href="javascript: void(0);">
            <i class="bx bx-wrench font-size-16 align-middle me-1"></i>
            Şifre Değiştir
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logoutOperation" class="text-danger">
            <i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            Çıkış Yap
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <CurrentActionsDialog
          :showDialog="showCurrentActionsDialog"
          :currentProp="currentActionsProp"
          @dialogChange="data => (showCurrentActionsDialog = data)"
      ></CurrentActionsDialog>
      <ChangePasswordDialog
          :page-prop="'topBar'"
          :userProp="userDataPasswordDialog"
          :showDialog="showChangePasswordDialog"
          @dialogChange="(data) => (showChangePasswordDialog = data)"
      ></ChangePasswordDialog>
      <ProductDetail
          :stock-code="productDetailStockCode"
          :showDialog="showProductDetailDialog"
          @dialogChange="e => (showProductDetailDialog = e)"
      ></ProductDetail>
    </div>
  </header>
</template>

<script>
import i18n from "../i18n";

import simplebar from "simplebar-vue";
import {layoutComputed} from "@/state/helpers";
import {addBase64Prefix, logoFromConfig} from "@/base64Helper";
import {mapState, mapActions, mapMutations, mapGetters} from "vuex";
import Swal from "sweetalert2";
import CurrentActionsDialog from "@/components/current/dialogs/CurrentActionsDialog.vue";
import ChangePasswordDialog from "@/components/management/user-management/dialogs/ChangePasswordDialog.vue";
import SearchSelect from "@/components/searchSelect.vue";
import {swalToast} from "@/helpers/swalToast";
import ProductDetail from "@/pages/views/product/ProductDetail.vue";

/**
 * Horizontal-topbar component
 */
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    }
  },
  computed: {
    ...layoutComputed,
    ...mapState("dashboard", ["reportCompanyData"]),
    ...mapState("auth", ["user", "token"]),
    ...mapState("cart", ["cartList", "current"]),
    ...mapState("settings", ["erpSettings", "generalSettings"]),
    ...mapActions("current", ["fetchCurrentList"]),
    ...mapGetters("dashboard", ["getCurrencies"]),
    ...mapState("currencies", ["dollar", "euro", "pound"]),
    ...mapGetters("settings", ["getCurrencyLabels"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
    route: {
      get() {
        return this.$route.fullPath;
      }
    }
  },
  components: {
    ProductDetail,
    SearchSelect,
    ChangePasswordDialog,
    CurrentActionsDialog,
    simplebar,
  },
  data() {
    return {
      showChangePasswordDialog: false,
      userDataPasswordDialog: null,
      currentActionsProp: null,
      showCurrentActionsDialog: false,
      searchStock: null,
      searchStockTimeout: null,
      searchStockLoading: false,
      selectedStock: null,
      productDetailStockCode: null,
      showProductDetailDialog: false,

      stockList: [],
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English"
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French"
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish"
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese"
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic"
        }
      ],
      current_language: i18n.locale,
      text: null,
      flag: null,
      value: null
    };
  },
  mounted() {
    this.setSettings();
    this.value = this.languages.find(x => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    if (this.current) this.getCartList();
    this._fetchSingleCurrent();
  },
  methods: {
    openChangePasswordDialog(user) {
      this.userDataPasswordDialog = Object.assign({}, user);
      this.showChangePasswordDialog = !this.showChangePasswordDialog;
    },
    cancelCurrent() {
      swalToast.fire({
        title: "",
        text: "Cari seçimi iptal edildi",
        icon: "error",
        iconColor: "red",
      });
      this.setCurrent(null);
      this.setCartList([]);
    },
    logoFromConfig() {
      return logoFromConfig
    },
    addBase64Prefix,
    ...mapActions("cart", [
      "removeProductFromCartList",
      "fetchSingleCartList",
      "cartStockDelete",
      "stockToCartAdd"
    ]),
    ...mapActions("current", ["fetchSingleCurrent"]),
    ...mapMutations("cart", [
      "setCurrent",
      "setCartCategoryList",
      "setCartList",
      "setCartListMetaData"
    ]),
    ...mapActions("auth", ["logout"]),
    ...mapActions("stock", ["fetchStockList"]),
    ...mapActions("settings", ["fetchSettings"]),
    async setSettings() {
      await this.fetchSettings({params: {}, body: {}});
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    async logoutOperation() {
      await this.logout();
      await this.setCurrent(null);
      await this.setCartCategoryList([]);
      await this.setCartList([]);
      await this.setCartListMetaData({});
    },
    async searchStockList() {
      this.stockList = await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: 30,
          userId: this.user.UserId
        },
        body: {
          stock: this.searchStock,
          GenericCategories: null
        },
        onlyData: true,
        loading: false
      });
      this.searchStockLoading = false;
    },
    async getCartList() {
      if (
          this.user.RoleGroupId === 3 ||
          (this.user.RoleGroupId === "3" && !this.current.code)
      ) {
        this.current.code = this.user.userInfo.erpCode;
      }
      if (this.current.code) {
        await this.fetchSingleCartList({
          params: {},
          body: {
            UserId: this.user.UserId,
            CurrentCode: this.current.code
          }
        });
      }
    },
    async _fetchSingleCurrent() {
      if (this.user.RoleGroupId === 3 || this.user.RoleGroupId === "3") {
        // TODO : müşteri cari seçimi özelliği ile açılacak.
        if (!this.current) {
          let current = await this.fetchSingleCurrent({
            params: {
              currentCode: this.user.userInfo.erpCode
            }
          });
          this.setCurrent(current);
        }
      }
    },
    async changeQuantityOfProduct(product, quantity) {
      if (!this.current) {
        Swal.fire({
          title: "Ürün Ekleme Başarısız",
          text: "Cari listesinden cari seçimi yapmalısınız",
          icon: "error",
          confirmButtonText: "Tamam"
        });
      } else {
        await this.stockToCartAdd({
          params: {
            userId: this.user.UserId,
            currentCode: this.current.code
          },
          body: {
            StockCode: product.stockCode,
            Quantity: quantity,
            Unit: 1,
            Discount1: product.discount1, //Neye karşılık geliyor ?
            Discount2: product.discount2, //Neye karşılık geliyor ?
            isBasket: false,
            Description: null
          }
        });
      }
    },
    async cartStockRemove(product) {
      await this.cartStockDelete({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
          stockCode: product.stockCode
          //basketCode: null //sepet Kodu ise yollanacak
        },
        body: {}
      });
    },
    openCurrentActionsDialog(data) {
      this.currentActionsProp = data;
      this.showCurrentActionsDialog = true;
    },
    goProductDetail(stockCode) {
      this.showProductDetailDialog = true;
      this.productDetailStockCode = stockCode;
    },
    fetchCurrencyLabel(currencyType) {
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return '₺';
    },
  },
  watch: {
    selectedStock(newVal) {
      if (newVal)
        this.goProductDetail(newVal)
    },
    searchStock(newVal) {
      this.stockList = [];
      if (newVal === "" || newVal === null) {
        if (this.searchStockTimeout) clearTimeout(this.searchStockTimeout);
      } else {
        this.searchStockLoading = true;
        if (this.searchStockTimeout) clearTimeout(this.searchStockTimeout);

        this.searchStockTimeout = setTimeout(() => {
          this.searchStockList();
        }, 1000);
      }
    },
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      }
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-scrollable");
              document.body.removeAttribute("data-layout-size");
              break;
            case "scrollable":
              document.body.setAttribute("data-layout-scrollable", "true");
              document.body.removeAttribute("data-layout-mode");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      }
    }
  }
};
</script>